import './InstaIcon.scss'
import { SocialIcon } from "react-social-icons";

const InstaIcon = () => {
  return (
    <div className="insta-icon">
      <SocialIcon
        style={{
          width: 60,
          height: 60
        }}
        fgColor="#ffffff"
        url="https://www.instagram.com/spotregistros"
      />
    </div>
  )
}

export default InstaIcon